// A sheet tied to the address (`?sheet=add-car`): a link can open it, and a phone's Back closes it.
import { useCallback } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router';

export function useRouteSheet(name: string): [open: boolean, setOpen: (open: boolean) => void] {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const open = params.get('sheet') === name;
  const setOpen = useCallback(
    (next: boolean) => {
      if (next === open) {
        return;
      }
      const search = new URLSearchParams(location.search);
      if (next) {
        search.set('sheet', name);
        navigate({ search: `?${search}` }, { state: { sheet: name } });
      } else if ((location.state as { sheet?: string } | null)?.sheet === name) {
        // Opened here: Back takes the address to where it was.
        navigate(-1);
      } else {
        search.delete('sheet');
        const rest = search.toString();
        navigate({ search: rest ? `?${rest}` : '' }, { replace: true });
      }
    },
    [open, name, navigate, location.search, location.state],
  );
  return [open, setOpen];
}
